import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  	mainNum:1,
  	
  	songIndex:0,
  	songList:'',
    songHash:'',
    songName:'',
    singerName:'',
    imgUrl:'http://www.xi-g.com/dist/logo.png',
    songUrl:'',
    isplay:false,
    iscurrent:-1,
    guodu:true,
    searchTotal:0,
    rankTime:'',
    rankList:'',
    rankImgUrl:'',
    rankPageIndex:'',
    navShow:true,
    
    searchFlag:0,
    plistText:'',
    
    singerList:'',
    bigPlayShow:false,
    bigImgUrl:'',
    timeLength:'',
    mycurrentTime:'',
    songLrc:'',
    imgPause:'',
  },
  getters: {
  	mainNum: state=>state.mainNum,
  	songList: state=>state.songList,
    songHash: state=>state.songHash,
    songName: state=>state.songName,
    singerName: state=>state.singerName,
    imgUrl: state=>state.imgUrl,
    songUrl: state=>state.songUrl,
    isplay: state=>state.isplay,
    iscurrent: state=>state.iscurrent,
    songIndex: state=>state.songIndex,
    guodu: state=>state.guodu,
    searchTotal: state=>state.searchTotal,
    rankTime: state=>state.rankTime,
    rankList: state=>state.rankList,
    rankImgUrl: state=>state.rankImgUrl,
    rankPageIndex: state=>state.rankPageIndex,
    navShow: state=>state.navShow,
    searchFlag: state=>state.searchFlag,
    plistText: state=>state.plistText,
    singerList: state=>state.singerList,
    bigPlayShow: state=>state.bigPlayShow,
    bigImgUrl: state=>state.bigImgUrl,
    timeLength: state=>state.timeLength,
    mycurrentTime: state=>state.mycurrentTime,
    songLrc: state=>state.songLrc,
    imgPause: state=>state.imgPause,
  },
  mutations: {
  	setMainNum: (state, mainNum)=> {
      state.mainNum = mainNum;
    },
   	setSongHash: (state, songHash)=> {
      state.songHash = songHash;
    },
    setSongName: (state, songName)=> {
      state.songName = songName;
    },
    setSingerName: (state, singerName)=> {
      state.singerName = singerName;
    },
    setImgUrl: (state, imgUrl)=> {
      state.imgUrl = imgUrl;
    },
    setSongUrl: (state, songUrl)=> {
      state.songUrl = songUrl;
    },
    isplayFlag: (state, flag)=> {
      state.isplay = flag;
    },
    setIscurrent: (state, iscurrent)=> {
      state.iscurrent = iscurrent;
    },
    setSongList: (state, songList)=> {
      state.songList = songList;
    },
    setSongIndex: (state, songIndex)=> {
      state.songIndex = songIndex;
    },
    setGuodu: (state, guodu)=> {
      state.guodu = guodu;
    },
    setSearchTotal: (state, searchTotal)=> {
      state.searchTotal = searchTotal;
    },
    rankTime: (state, rankTime)=> {
      state.rankTime = rankTime;
    },
    rankList: (state, rankList)=> {
      state.rankList = rankList;
    },
    rankImgUrl: (state, rankImgUrl)=> {
      state.rankImgUrl = rankImgUrl;
    },
    rankPageIndex: (state, rankPageIndex)=> {
      state.rankPageIndex = rankPageIndex;
    },
    navShow: (state, navShow)=> {
      state.navShow = navShow;
    },
    searchFlag: (state, searchFlag)=> {
      state.searchFlag = searchFlag;
    },
    plistText: (state, plistText)=> {
      state.plistText = plistText;
    },
    singerList: (state, singerList)=> {
      state.singerList = singerList;
    },
    bigPlayShow: (state, bigPlayShow)=> {
      state.bigPlayShow = bigPlayShow;
    },
    setBigImgUrl: (state, bigImgUrl)=> {
      state.bigImgUrl = bigImgUrl;
    },
    timeLength: (state, timeLength)=> {
      state.timeLength = timeLength;
    },
    mycurrentTime: (state, mycurrentTime)=> {
      state.mycurrentTime = mycurrentTime;
    },
    songLrc: (state, songLrc)=> {
      state.songLrc = songLrc;
    },
    imgPause: (state, imgPause)=> {
      state.imgPause = imgPause;
    },
  },
  actions: {
		getSongHash({commit,state}, hash){
        commit('setSongHash', hash);
    },
    playSong({commit,state}){
    	commit('setGuodu', true);
    	 var _this=this;
    	 var playHash=state.songList[state.iscurrent].hash
       $.ajax({ 
				type:"get",
				url: 'https://www.xi-g.com/api/agent_api/getSong?hash='+playHash,
				dataType:"json",
				success: function(data){
					// commit('setSongUrl', data.url);
					// commit('setSongName', data.songName);
					// commit('setSingerName', data.singerName);
					// commit('timeLength', data.timeLength);
					// //commit('setImgUrl', data.imgUrl.split('{size}').join('100'));
					// commit('setImgUrl', data.imgUrl.replace('{size}','100'));
					// commit('setBigImgUrl', data.imgUrl.replace('{size}','240'));
          // commit('isplayFlag',true);
          console.log(data.data, 'data.data')
          commit('setSongUrl', data.data.play_url);
					commit('setSongName', data.data.album_name);
					commit('setSingerName', data.data.author_name);
					commit('timeLength', data.data.timelength/1000);
					commit('setImgUrl', data.data.img);
					commit('setBigImgUrl', data.data.img);
          commit('isplayFlag',true);
          commit('songLrc', data.data.lyrics);
					// $.ajax({ 
					// 	type:"get",
					// 	url: "https://www.xi-g.com/api/agent_api/getSongLrc?hash="+playHash+"&timelength="+state.timeLength*100,
					// 	dataType:"text",
					// 	success: function(data){
					// 		commit('songLrc', data);
					//   }
					// });
				}
			});
			setTimeout(function() {
				document.getElementById('audioPlay').play();
				commit('setGuodu', false);
			}, 360);
			
    },
  }
});





// WEBPACK FOOTER //
// ./src/store/index.js